import React from 'react';
import ProgrammeLandingPage from './ProgrammeLandingPage';

const FellowshipsPage = () => <ProgrammeLandingPage kind="fellowship" />;

export default FellowshipsPage;
